export const isPriceZero = price => price === '£0.00'
